import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import AdminSidebar from './AdminSidebar';

interface DashboardLayoutProps {
  children: React.ReactNode;
 
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children  }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  
  // Close sidebar by default on mobile screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    
    // Initial check
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper min-h-screen bg-slate-50">
      <Navbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
  
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
   
      <main className={`overflow-auto transition-all duration-300 pt-16 min-h-screen bg-slate-100 ${sidebarOpen ? 'md:mr-60' : 'mr-0'}`}>
          {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
